export default {
    personal_token_page_title: '个人令牌中心',
    personal_token_create: '+ 创建个人令牌',
    personal_token_name: '令牌名称',
    personal_token_type: '令牌类型',
    personal_token_value: '个人令牌',
    personal_token_type_personal_token: '个人令牌',
    personal_token_type_game_wiki: 'gamewiki 令牌',
    personal_token_expire_time: '过期时间',
    personal_token_view: '查看',
    personal_token_renew: '续期',
    personal_token_revoke: '废弃',

    personal_token_create_modal_title: '创建个人令牌',
    personal_token_detail_modal_title: '令牌详情',
    personal_token_revoke_modal_title: '废弃个人令牌',

    personal_token_name_placeholder: '请输入令牌名称',
    personal_token_name_required: '请输入令牌名称',
    personal_token_name_too_long: '令牌名称最多50字符',
    personal_token_name_invalid: '仅支持中英文、数字、下划线',

    personal_token_security_warning: '请妥善保管您的个人令牌，注意个人信息安全，切勿泄露给他人',
    personal_token_valid_90_days: '3个月内有效',
    personal_token_show: '显示',
    personal_token_hide: '隐藏',
    personal_token_copy: '复制个人令牌',

    personal_token_type_game_wiki_exists_tip:
      '当前列表中已存在 gamewiki 令牌，如需创建，请先废弃当前 gamewiki 令牌',

    personal_token_valid_12_months: '12个月内有效',
    personal_token_renew_confirm_title: '确认续期个人令牌？',
    personal_token_renew_confirm_desc: '续期后旧令牌将失效，新令牌有效期默认为90天',
    personal_token_renew_confirm_desc_game_wiki:
      '续期后旧令牌将失效，新 gamewiki 令牌有效期默认为12个月',

    personal_token_revoke_warning: '废弃后令牌将立即失效，并从列表移除',
    personal_token_revoke_confirm: '确认废弃',

    personal_token_list_failed: '个人令牌列表加载失败，请稍后重试',
    personal_token_create_success: '创建成功',
    personal_token_create_failed: '创建失败，请稍后重试',
    personal_token_detail_failed: '获取令牌详情失败，请稍后重试',
    personal_token_not_found: '令牌不存在',
    personal_token_already_revoked: '令牌已被废弃',
    personal_token_service_error: '令牌服务异常，请稍后重试',
    personal_token_renew_success: '续期成功',
    personal_token_renew_failed: '续期失败，请稍后重试',
    personal_token_revoke_success: '废弃成功',
    personal_token_revoke_failed: '废弃失败，请稍后重试',
  };